import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const subjectsManifest: FeatureManifest = { id: 'subjects', path: 'subjects/*', navPath: '/subjects', label: 'Môn học', description: 'Quản lý môn học', load: () => import('./entry') }
